/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useState, useEffect, useRef } from 'react';
import { StyledPropertyListContainerDiv } from './index.styles';
import { PropertyCardComponent } from '../propertyCard';
import { renderedData } from '../../organisms/searchResults';
import { PaginationPanel } from '@marriott/mi-ui-library-shop';
import { SearchFilterContext, SearchResultContext, SearchResultAlertContext } from '../../index.context';
import { SearchActions } from '../../../store/store.action';
import { SearchFacetsConstants, RateNodeTypeToBeUsed, propertyCardHiddenAlertCodes } from '../../index.constant';
import AlertNotification from '../alerts';
import { PaginationSortByComponent } from '../paginationSortBy';
import MemberExclusiveBanner from '../memberExclusiveBanner';
import { logger } from '../../../../../../utils';
import { Messages } from '@marriott/mi-ui-library';
import { getRateBlock, isUnsuccessfulUserJourney } from '../../../lib/helper';
import { useSessionUpdateContext } from '../../../../../../context/SessionUpdateContext';
import { StyledSearchResultMapContainer } from '../../organisms/searchResults/index.styles';
import { usePageContext } from '../../../../../../context/PageContext/index';
import clsx from 'clsx';
import { useCheckBreakpoint } from '../../../../../../hooks';
import { MapLazyComponent } from '../mapComponent/MapLazyComponent';
import { getPriceByDecimalPoint, getCurrentPriceRateBlock, getCurrRateAmountBlock } from '../../../lib/helper';
import { SearchRateType, SearchResultDataNode } from '../../../store/store.type';
const PropertyListComponent: React.FC<{
  isMobileState?: boolean;
  handleStaleError?: boolean;
  memberExclusiveBannerDetails?: {
    featureSelected: boolean;
    numberOfNights: number;
    pointsChecked: boolean;
  };
  alertLinkClickFn: () => void;
  handlePopUpOpen: (popUpOenState: boolean) => void;
  enableListView: (listViewClicked: boolean) => void;
  handleNextClick?: (isInitialLoadData: boolean) => void;
  isDrawerVisible: boolean;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  segmentId?: string;
  isLatLongAvailable?: boolean;
}> = ({
  isMobileState = false,
  handleStaleError = false,
  memberExclusiveBannerDetails,
  alertLinkClickFn,
  handlePopUpOpen,
  enableListView,
  handleNextClick,
  isDrawerVisible,
  segmentId,
  isLatLongAvailable,
  setFetchCurrencyConversionFactors,
}) => {
  const {
    isMapViewEnabled,
    setFeatureSelected,
    isFlexibleDateSearch,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any = useContext(renderedData);
  const { searchResult } = useContext(SearchResultContext);
  const { searchQueryState, setSearchQuery } = useContext(SearchFilterContext);
  const { searchResultAlerts } = useContext(SearchResultAlertContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const { currentLocale } = usePageContext();
  const [loadAllResults, setLoadAllResults] = useState<boolean>(false);
  const loadAll = useRef<boolean>(false);

  const searchResults = searchResult?.edges;

  const PageSize = searchQueryState[SearchFacetsConstants.limit];

  const { log } = logger({})('SearchResults/propertyList');

  log.debug('search result', searchResult);

  const [currentPage, setCurrentPage] = useState(
    Number(searchResult?.pageInfo?.currentOffset ? searchResult?.currentOffset : 0) !== 0 &&
      searchQueryState?.currentCurrency != 'default'
      ? Math.ceil((Number(searchResult?.pageInfo?.currentOffset) + 1) / PageSize)
      : searchQueryState[SearchFacetsConstants.offset] !== 0
      ? Math.ceil((searchQueryState[SearchFacetsConstants.offset] + 1) / PageSize)
      : 1
  );

  const handleScroll = () => {
    if (!loadAll.current) {
      setLoadAllResults(true);
      loadAll.current = true;
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const onPageItemClick = (page: number): void => {
    setFetchCurrencyConversionFactors(true);
    setFeatureSelected(true);
    setCurrentPage(page);
    setPageNumber(page);
    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: PageSize * (page ? page - 1 : 0),
        [SearchFacetsConstants.goToNextPage]: PageSize * (page ? page - 1 : 0),
      },
    });
    setInteractionsSelected({ ...interactionsSelected, pagination: true });
  };

  const getDataProperty = (result: {
    node: {
      property: { basicInformation: any; id: any };
      rates: SearchRateType[] | undefined;
      basicInformation: any;
      id: any;
    };
  }) => {
    const flexibleOrManyProperty =
      isFlexibleDateSearch || (searchResultAlerts.type && searchResultAlerts.type === 'warning');
    const currRateNode = getCurrentPriceRateBlock(searchQueryState, result?.node?.rates);
    const currRateDetails = getCurrRateAmountBlock(currRateNode);

    let priceInfo: any;
    // update logic for priceInfo depending on amountPlusMandatoryFees/amount
    if (currRateDetails?.amountPlusMandatoryFees) {
      priceInfo = flexibleOrManyProperty ? null : currRateDetails?.amountPlusMandatoryFees;
    } else {
      priceInfo = flexibleOrManyProperty ? null : currRateDetails?.amount;
    }
    const basicInformation = result?.node?.property?.basicInformation;
    const flexibleInformation = result?.node?.basicInformation;
    const amountObj = priceInfo;

    const dataPropObj = {
      lat: isFlexibleDateSearch ? flexibleInformation?.latitude : basicInformation?.latitude,
      long: isFlexibleDateSearch ? flexibleInformation?.longitude : basicInformation?.longitude,
      brand: isFlexibleDateSearch ? flexibleInformation?.brand?.id : basicInformation?.brand?.id,
      marshacode: isFlexibleDateSearch ? result?.node?.id : result?.node?.property?.id,
      hwsInLanguageMissing: 'false',
      currency: basicInformation?.currency,

      price: getPriceByDecimalPoint(
        amountObj?.amount,
        amountObj?.decimalPoint,
        searchQueryState,
        currentLocale,
        amountObj?.currency
      ),
      hotelName: basicInformation?.name,
      propMarkerLabel: '',
      propMarkerBedLabel: '',
    };
    return JSON.stringify(dataPropObj);
  };

  const [noRatesAvailableForAnyProperty, setNoRatesAvailableForAnyProperty] = useState(false);
  const determineIfAllRatesUnavailable = (searchResults: (SearchResultDataNode | null)[] | null | undefined) => {
    if (searchResults?.length) {
      let isRatesAvailableForAnyProperty = false;
      for (let i = 0; i < searchResults?.length; i++) {
        const result = searchResults[i];
        const currRateNode = getCurrentPriceRateBlock(searchQueryState, result?.node?.rates);
        const pointsRateBlock = getRateBlock(result?.node?.rates, 'points');
        const eeoRateBlock = getRateBlock(result?.node?.rates, 'eeo');
        if (
          !isFlexibleDateSearch &&
          (currRateNode?.rateModes?.lowestAverageRate ||
            pointsRateBlock?.rateModes?.pointsPerUnit ||
            eeoRateBlock?.rateModes?.lowestAverageRate)
        ) {
          isRatesAvailableForAnyProperty = true;
          break;
        }
      }
      if (!isRatesAvailableForAnyProperty) {
        setNoRatesAvailableForAnyProperty(true);
      }
    }
  };
  useEffect(() => {
    determineIfAllRatesUnavailable(searchResults);
  }, [searchResults]);

  const isViewportXL = useCheckBreakpoint('viewportXl');
  const isViewportM = useCheckBreakpoint('viewportM');
  return (
    <div
      className={
        isMapViewEnabled
          ? clsx(
              'search-results-container',
              'color-scheme1',
              'search-map-view-result-container'
              // isDrawerVisible ? 'active-drawer' : '',
              // popPupOpen ? 'map-popup-position' : ''
            )
          : 'search-results-container'
      }
    >
      {!(isMapViewEnabled && !isViewportM) && (
        <StyledPropertyListContainerDiv>
          <div
            className={clsx(
              isViewportXL && !isDrawerVisible && isMapViewEnabled ? `active-drawer-list` : ``,
              !isViewportXL && isMapViewEnabled ? `active-drawer-list` : ``
            )}
          >
            <div
              className={clsx(
                'container property-card-outer-container',
                isMapViewEnabled ? `color-scheme1 outer-map-view-class` : `pr-0`
              )}
            >
              {!memberExclusiveBannerDetails?.featureSelected &&
                isMapViewEnabled &&
                (memberExclusiveBannerDetails?.numberOfNights ?? 0) >= 4 &&
                memberExclusiveBannerDetails?.pointsChecked && (
                  <MemberExclusiveBanner
                    numberOfNights={memberExclusiveBannerDetails.numberOfNights}
                    pointsChecked={memberExclusiveBannerDetails.pointsChecked}
                  />
                )}
              {isMapViewEnabled && (
                <PaginationSortByComponent
                  isMobileState={isMobileState}
                  className="pagination-container propertyList"
                  segmentId={segmentId}
                  isLatLongAvailable={isLatLongAvailable}
                  setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                />
              )}
              {isMapViewEnabled && searchResultAlerts?.errorMessage && !isUnsuccessfulUserJourney() ? (
                <AlertNotification
                  setLinkClick={alertLinkClickFn}
                  clickTrackingText="Phoenix Search Results | Alert: Set default currency link clicked |internal"
                />
              ) : (
                ''
              )}
              {isMapViewEnabled &&
              searchResultAlerts?.errorMessage &&
              searchResultAlerts?.showPageAndFilter &&
              isUnsuccessfulUserJourney() ? (
                <Messages
                  className="unsuccess-full-journey"
                  messageType="warning"
                  messageVariation={false}
                  messageHeading={searchResultAlerts?.heading}
                  messageText={searchResultAlerts?.errorMessage}
                />
              ) : (
                ''
              )}
              <div
                className={
                  ' property-card-container ' +
                  (isMapViewEnabled ? ` map-view-selected ` : ``) +
                  (searchResultAlerts?.errorMessage ? 'with-alerts' : '')
                }
              >
                {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                {!propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '') &&
                  searchResults?.map((result: any, idx: any) => {
                    return (
                      <div
                        className=" property-card"
                        key={idx}
                        data-marsha={isFlexibleDateSearch ? result?.node?.id : result?.node?.property?.id}
                        data-brand={
                          isFlexibleDateSearch
                            ? result?.node?.basicInformation?.brand?.id
                            : result?.node?.property?.basicInformation?.brand?.id
                        }
                        data-map="true"
                        data-property={getDataProperty(result)}
                        data-pnum={idx}
                      >
                        {(!loadAllResults && idx < 10) || loadAllResults || isMapViewEnabled ? (
                          <PropertyCardComponent
                            propertyHandleStaleError={handleStaleError}
                            propertyCardData={result}
                            idx={idx}
                            handlePopUpOpen={handlePopUpOpen}
                            pageNumber={pageNumber}
                            noRatesAvailableForAnyProperty={noRatesAvailableForAnyProperty}
                          />
                        ) : null}
                      </div>
                    );
                  })}
              </div>
            </div>
            {isMapViewEnabled ? <div className="separator t-horizontal-vertical-rule"></div> : ''}
            {!propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '') && (
              <div className=" pagination-container">
                <PaginationPanel
                  currentPage={currentPage}
                  totalCount={searchResult?.total ?? 0}
                  pageSize={PageSize}
                  onPageChange={(page: number): void => onPageItemClick(page)}
                />
              </div>
            )}
          </div>
        </StyledPropertyListContainerDiv>
      )}
      {isMapViewEnabled && (
        <StyledSearchResultMapContainer className="map-container">
          <MapLazyComponent
            isMapViewEnabled={true}
            onListViewClickHandler={enableListView}
            handleNextClick={handleNextClick}
            isDrawerVisible={isDrawerVisible}
          />
        </StyledSearchResultMapContainer>
      )}
    </div>
  );
};

export default PropertyListComponent;
